angular.module('impactx.combibudget').controller('CombiBudgetCTTListCtrl', [
    '$routeParams',
    CombiBudgetCTTListCtrl
]);

function CombiBudgetCTTListCtrl($routeParams) {

    this.meta = {
        rowTemplate: 'modules/combibudget/templates/cttlist.row.tmpl.html',
        headerTemplate: 'modules/combibudget/templates/headerSummary.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/combibudget/cttlist',
        id: "combibudgetcttlist",
        excelExport: true,
        params: {
            id: $routeParams.id
        },
        valuesInteger: [{name: "id", value: $routeParams.id}]
    };

    this.getMeta = function () {
        return this.meta;
    };
}